import { Injectable } from '@angular/core';
import { TriggerbeeRequester, TriggerbeeApi } from '../../core/triggerbee/triggerbee-requester.service';
import { RequestResult } from '../../core/triggerbee/request-result';
import { LoggerFactory, Logger } from '../../core/logger.service';

@Injectable()
export class EmailConfirmService {
  private readonly logger: Logger;

  constructor(
    loggerFactory: LoggerFactory,
    private readonly requester: TriggerbeeRequester,
  ) {
    this.logger = loggerFactory.get('EmailConfirmService');
  }

  public async confirmAsync(email: string, verificationCode: string): Promise<RequestResult<string>> {
    // Validate parameters
    if (!email) {
      this.logger.error('Email is undefined');
      return undefined;
    }
    if (!verificationCode) {
      this.logger.error('Verification code is undefined');
      return undefined;
    }

    // Send request
    const response = await this.requester.postAsync<string>(TriggerbeeApi.Gateway, 'authentication/email/verify', {
      email: email,
      code: verificationCode,
    });

    return response;
  }
}
